import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import helpers from './../../networking/Helpers';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';

class UserOpenShift extends Component {
    constructor(props) {
        super(props);
        this.state={
          data_list:[],
          date:'',
          user_id:'',
          name:'',
          image:'',
          total_shift: '00:00',
          total_hour: '00:00',

          shift_id: '',
          day:'',
        
          schema_id : '',
          assignment_list : [],
          assignment_id : '',
          assignment_color:'#ced4da',
          start:'',
          end:'',
          note:'',
          overtime:'',salary_amt:'',salary_type:2,
          breaks:'',
          shareholders: [
           {    from_time:"",
                to_time: ""
          }],
          is_apply:0
        }
    }
    componentDidMount(){
        this.setState({user_id:localStorage.getItem('userid')});
        this.setState({date:helpers.getCurrentDate()});
        this.getOpenShiftList(helpers.getCurrentDate());
        this.getAssignment();
    }

    getOpenShiftList(date){
      var formData=new FormData();
      formData.append("user_id", localStorage.getItem('userid'));
      post(Constent.GETUSERSHIFT,formData).then(response=>{
          if(response.status===1){
            this.setState({
                data_list:response.open_shift,
                total_shift:response.open_shift.length,
                //total_hour:response.total_hour, 
            });
          }
      })
    }

    
    getAssignment(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'))
        post(Constent.SHIFT,formData).then(response=>{
               if(response.status===1){
                this.setState({assignment_list:response.assignments});
            }
        })
    }

    
    applyFreeShift(){
        let user_id= localStorage.getItem('userid');
        var formdata=new FormData();
        formdata.append("user_id",user_id);
        formdata.append("event_id",this.state.shift_id);
        post(Constent.APPLYFREESHIFT,formdata).then(response =>{
            if(response.status===1){
              window['modalClose']();
              this.getOpenShiftList(this.state.date);
              Alert.success({title: response.msg});
            } else{
                Alert.error({title: response.msg});
            }
        })
    };
    render() {
        const { t } = this.props;
        return (
            <>
            <div className="header-area shift-userpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.shift_sc_open_shift')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="shift-userpage transaction-area mg-bottom-40">
                        <div style={{marginTop:70}}>
                        <div className="text-right pd-right-10">
                            {t('lang.link_text__go_to')}: <Link to={'/shift-user/'+localStorage.getItem("userid")} className="link show-all"> {t('lang.shift_sc_my_shift')} </Link>
                        </div>
                        
                        {this.state.data_list.length > 0 ? '' : <p className="text-center"> {t('lang.shift_sc__no_open_shift_available')}</p> }
                            {this.state.data_list.map(({ assignment_id, assignment_name,color, start,end, day,breaks,notes,overtime,salary_amt,salary_type, schema_id, shift_id, status,date, is_apply }) => (
                            <div key={Math.random()}>
                            <div className="single-goal">
                                <Link to={'#'} 
                                data-toggle="modal" data-target="#apply-shift-modal"
                                onClick={()=>{
                                  this.setState({
                                    shift_id : shift_id,
                                    assignment_id : assignment_id,
                                    assignment_color: color,
                                    start: start,
                                    end: end,
                                    day : day,
                                    date : date,
                                    note:notes,
                                    overtime: overtime,
                                    salary_amt:salary_amt,
                                    salary_type:salary_type,
                                    breaks:breaks,
                                    is_apply:is_apply
                                })
                                }}
                                >
                                <div className="row">
                                    <div className="col-3" >
                                        <div className="left-div" style={{borderColor:color}}>
                                        <small className="mm">{moment(date, "YYYY-MM-DD").format("MMM")}</small>
                                        <p className="dd">{moment(date, "YYYY-MM-DD").format("DD")}</p>
                                        </div>
                                    </div>
                                    <div className="col-6 pr-0 border-left-1 center-div">
                                        <div>{start} - {end}</div>
                                        <span style={{color:color}}>{assignment_name}</span>
                                        {(is_apply === 1) ?
                                          <span className="applied-shift">{t('lang.shift_sc_applied')}</span>
                                          : ''}
                                    </div>
                                    <div className="col-3 last-div center">
                                        <i className="la la-angle-right"></i>
                                    </div>
                                </div>
                                        </Link>
                            </div>
                            </div>
                            ))}
                        </div>
                </div>
                {/* transaction End */}

           
                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                               <div className="col-8 offset-2">
                                    <div><span>{t('lang.home_sc_total_shift')}:  {this.state.total_shift} </span></div>
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'shift-user/'+localStorage.getItem('userid')}>
                                        <i className="fa fa-reply" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}

            {/*  apply-shift-modal start */}
            <div id="apply-shift-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="row mb-3">
                                <div className="col-6">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.start} 
                                        readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.end} 
                                        readOnly={true} />
                                    </div>
                                </div>
                                </div> 


                                <div className="input-group mb-3">
                                    <select className="form-control form-control-lg"
                                        style={{borderLeft: '20px solid', borderColor: this.state.assignment_color}}
                                        value={this.state.assignment_id} 
                                        readOnly={true} >
                                      <option>{t('lang.shift_sc_select_shift')}</option>
                                      {this.state.assignment_list.map(({ id,name, choose_absence,calculate_it_as }) => (
                                        <option value={id} title={choose_absence} key={Math.random()} >{name}</option>
                                      ))}
                                    </select>
                                </div>
                                
                                {/* Basic Tabs */}
                                <div className="widget has-shadow">
                                    <div className="widget-body sliding-tabs">
                                        <ul className="nav nav-tabs" id="example-one" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="base-tab-11" data-toggle="tab" href="#tab-111" role="tab" aria-controls="tab-11" aria-selected="true">{t('lang.timestamp_sc_note')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-22" data-toggle="tab" href="#tab-222" role="tab" aria-controls="tab-22" aria-selected="false">{t('lang.common_text_break')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-33" data-toggle="tab" href="#tab-333" role="tab" aria-controls="tab-33" aria-selected="false">{t('lang.shift_sc_overtime')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-44" data-toggle="tab" href="#tab-444" role="tab" aria-controls="tab-44" aria-selected="false">{t('lang.shift_sc_amount')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-3">
                                            <div className="tab-pane fade show active" id="tab-111" role="tabpanel" aria-labelledby="base-tab-11">
                                                <input type="text" className="form-control form-control-lg"
                                                value={this.state.note} 
                                                placeholder={t('lang.flex_sc_the_note_here')} 
                                                readOnly={true} />
                                            </div>

                                            <div className="tab-pane fade" id="tab-222" role="tabpanel" aria-labelledby="base-tab-22">
                                                    {this.state.shareholders.map((shareholder, idx) => (
                                                        <div className="row mb-3" key={Math.random()}>
                                                            <div className="col-6">
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.from_time} readOnly={true}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.to_time} readOnly={true}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-2"> 
                                                               
                                                            </div>
                                                        </div>    
                                                    ))}

                                            </div>

                                            <div className="tab-pane fade" id="tab-333" role="tabpanel" aria-labelledby="base-tab-33">
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.overtime} 
                                                placeholder={t('lang.shift_sc_overtime_in_percentage')} 
                                                readOnly={true} />
                                            </div>
                                            <div className="tab-pane fade" id="tab-444" role="tabpanel" aria-labelledby="base-tab-44">
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio1" value="1" name="salary_type" checked={ (this.state.salary_type === '1' || this.state.salary_type === 1) ? true : false} readOnly={true} />
                                                  <label className="form-check-label" htmlFor="inlineRadio1">{t('lang.shift_sc_hourly')} </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio2" value="2" name="salary_type" checked={ (this.state.salary_type === '2' || this.state.salary_type === 2) ? true : false} readOnly={true} />
                                                  <label className="form-check-label" htmlFor="inlineRadio2">{t('lang.shift_sc_shift')} </label>
                                                </div>
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.salary_amt} 
                                                placeholder={t('lang.shift_sc_amount')}
                                                readOnly={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Basic Tabs */}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" 
                            onClick={()=>{
                                    Alert.confirm({
                                    position:'toast-top-full-width',
                                    message: t('lang.message_are_you_sure'),
                                    btn_yes: t('lang.btn_text_yes_do_it'),
                                    action: () =>{   
                                        this.applyFreeShift();
                                    }
                                })
                            }}>{this.state.is_apply === 1 ? t('lang.shift_sc_giveaway') : t('lang.shift_sc_apply_for_shift')}</button>
                        </div>
                    </div>
                </div>
            </div>

            </>
        );
    }
}

export default withTranslation('common')(UserOpenShift);